import React, { useState, useEffect } from 'react';
import QrReader from 'react-qr-reader';
import { Grid } from '@material-ui/core';
import { useNavigate } from 'react-router-dom';
import ButtonStyle from '../components/button';
import ModalInfo from '../components/InfoModal';

function Token() {
  const [data, setData] = useState('No result');
  const [token, setToken] = useState('');
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const handleClose = () => {
    setOpen(false);
    navigate('/');
  };

  const postToToken = (result) => {
    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        wallet: result,
      }),
    };
    let url = 'https://t77wj8-8081.csb.app/callalchemy';
    fetch(url, config)
      .then((response) => response.json())
      .then((val) => {
        if ('receipt' in val) {
          console.log(val);
          setOpen(true);
        } else {
          setData(val.code);
        }
      })
      .catch((err) => {
        setData(err);
        setOpen(false);
      });
     
  };

  const handleErrorWebCam = (error) => {
    console.log(error);
  };
  const handleScanWebCam = (result) => {
    if (result) {
      setData(`your fantom wallet is: ${result}`);
      setToken(result);
    }
  };
  const handleClaim = () => {
    if (token) {
      if (!open) {
        setOpen(true);
        postToToken(token);
      }
    }
  };

  // Set up a timer to navigate to the home page after 20 seconds of inactivity
  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/');
    }, 30000); // 20 seconds in milliseconds

    return () => {
      clearTimeout(timer);
    };
  }, [navigate]);

  return (
    <div className="App">
      <div className="container">
        <label className="title">Step 3</label>
        <p>Scan your registered QR code on your ewallet or card , Tokens will be sent to this address</p>
        <Grid container style={{ width: window.innerWidth < 1000 ? '100%' : '25%' }}>
          <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
            <QrReader
              delay={300}
              style={{ width: '100%' }}
              onError={handleErrorWebCam}
              onScan={handleScanWebCam}
              facingMode="environment"
            />
          </Grid>
        </Grid>
        <p>{data}</p>
        <p>Disclaimer: This is a demo and the funds are not real, but intended for testing purposes</p>
        <ButtonStyle Text="Claim your funds!" onClick={handleClaim} />
      </div>
      <ModalInfo flag={open} close={handleClose} />
    </div>
  );
}

export default Token;
